// extracted by mini-css-extract-plugin
export default {"container":"Region__container___3Nbzb","content":"Region__content___1dFGS","actions":"Region__actions___2mxQr"};